import { useMediaQuery } from "@mui/material"

export default function useDeviceType() {
  const isMobile = useMediaQuery("(max-width:767px)")
  const isTablet = useMediaQuery("(min-width:768px) and (max-width:1024px)")
  const isDesktop = useMediaQuery("(min-width:1025px)")
  return { isMobile, isTablet, isDesktop }
}
